import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBookDictionary = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 6C7.75 5.58579 8.08579 5.25 8.5 5.25H15.5C15.9142 5.25 16.25 5.58579 16.25 6C16.25 6.41421 15.9142 6.75 15.5 6.75H8.5C8.08579 6.75 7.75 6.41421 7.75 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75H14.5C14.9142 9.75 15.25 9.41421 15.25 9C15.25 8.58579 14.9142 8.25 14.5 8.25H9.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.03 18.7368V4.74323C3.03 3.20081 4.30567 1.98999 5.84 1.98999H18.17C19.7043 1.98999 20.98 3.20081 20.98 4.74323V18.7368C20.98 20.2792 19.7043 21.49 18.17 21.49H5.84C4.30567 21.49 3.03 20.2792 3.03 18.7368ZM5.84 3.48999C5.09432 3.48999 4.53 4.06847 4.53 4.74323V16.5052C4.93515 16.3322 5.38515 16.25 5.84 16.25H18.17C18.9157 16.25 19.48 15.6715 19.48 14.9968V4.74323C19.48 4.06847 18.9157 3.48999 18.17 3.48999H5.84ZM19.48 17.4334C19.0873 17.636 18.6408 17.75 18.17 17.75H5.84C5.40225 17.75 5.06293 17.8731 4.84989 18.0429C4.65335 18.1995 4.53 18.419 4.53 18.7368C4.53 19.4115 5.09432 19.99 5.84 19.99H18.17C18.9157 19.99 19.48 19.4115 19.48 18.7368V17.4334Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconBookDictionary as ReactComponent };
